<template>
  <div class="page-wrapper">
    <div class="cg-crumb">
        <btn-back />
        <span class="item">库存管理</span>
        <em class="gap">/</em>
        <span class="item">修改库存</span>
    </div>
    <div class="cg-main-title">修改库存</div>
    <div class="stock-content">
      <div class="cg-mod-title">基本信息</div>
      <div class="basic-wrap">
        <div class="img-wrap">
          <el-image
            class="img"
            :src="goodsImage"
            fit="cover"
            :preview-src-list="goodsImageList"
          ></el-image>
        </div>
        <div class="basic-info">
          <el-row>
            <el-col :span="24"><div class="line">
              <span class="lab">商品名称： </span>
              <span class="val tit">{{detail.itemName}}</span>
            </div></el-col>
             <el-col :span="8"><div class="line">
              <span class="lab">所属品牌： </span>
              <span class="val">{{detail.brand}}</span>
            </div></el-col>
             <el-col :span="16"><div class="line">
              <span class="lab">所属类目：  </span>
              <span class="val">{{detail.productCategory || '--'}}</span>
            </div></el-col>
            <el-col :span="8"><div class="line">
              <span class="lab">商品款号：  </span>
              <span class="val">{{detail.styleNumber}}</span>
            </div></el-col>
             <el-col :span="16"><div class="line">
              <span class="lab">商品ID：  </span>
              <span class="val">{{detail.item_id}}</span>
            </div></el-col>
          </el-row>
        </div>
      </div>
      <div class="cg-mod-title mgt">尺码数量</div>
      
      <div class="stock-data">
        <div class="line">
          <span class="lab">销售价：</span>
          <span class="val">{{detail.price | price}} 元</span>
        </div>
        <div class="line">
          <span class="lab">供货价：</span>
          <span class="val">{{supplierPrice}} 元</span>
        </div>
        <div class="line">
          <span class="lab">结算价格：</span>
          <span class="val">{{settlePrice}}元</span>
        </div>
        <div class="line">
          <span class="lab">吊牌价：</span>
          <span class="val">{{detail.originPrice | price}} 元</span>
        </div>
        <div class="line">
          <span class="lab">总库存：</span>
          <span class="val">{{detail.totalStock}} 件</span>
        </div>
      </div>
      <div style="padding-bottom: 16px" v-show="!colorSizeEditShow">
        <button class="cg-btn" type="button" @click="editColorSize">修改颜色尺码</button>
      </div>
      <div class="cg-form-mod custom" v-show="colorSizeEditShow">
        <div class="line-lab">编辑商品颜色</div>
        <div class="color-list-wrap">
          <div class="item" v-for="(item, index) in colorArr" :key="index">
              <i class="el-icon-check color-checked" :class="{isdisabled: item.noDelete}" v-if="item.color.length>0 || item.noDelete" @click="colorItemDel(item, index)"></i>
              <i class="color-unchecked" v-else></i>
              <el-input size="mini" class="w26" v-model.trim="item.color" placeholder="请输入商品颜色" @input="colorItemInput(item, index)"></el-input>
              <div class="error" v-if="item.err">
                该颜色已存在！
              </div>
              <div class="error" v-if="item.err2">
                该颜色值不能为空！
              </div>
          </div>
        </div>
        <div class="line-lab">选择尺码</div>
        <div class="size-type-wrap" v-if="false">
          <el-radio-group v-model="sizeType" @change="handleSizeTypeChange">
            <el-radio :label="1">常规尺码</el-radio>
            <el-radio :label="2">裤装尺码</el-radio>
            <el-radio :label="3">童装尺码</el-radio>
          </el-radio-group>
        </div>
        <div class="size-list-wrap">
          <div v-show="sizeType == 1">
            <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList1" :label="item" :key="index"
            v-model="item.checked" :disabled="item.noEdit" @change="sizeItemChange"
            >{{item.dataName}}</el-checkbox>
          </div>
          <div v-show="sizeType == 2">
            <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList2" :label="item" :key="index"
              v-model="item.checked" :disabled="item.noEdit" @change="sizeItemChange"
            >{{item.dataName}}</el-checkbox>
          </div>
          <div v-show="sizeType == 3">
            <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList3" :label="item" :key="index"
              v-model="item.checked" :disabled="item.noEdit" @change="sizeItemChange"
            >{{item.dataName}}</el-checkbox>
          </div>
        </div> 
      </div>
      <div class="stock-table">
        <table class="table">
          <thead>
            <tr class="th">
              <th width="140">颜色</th>
              <th width="160">尺码</th>
              <th width="320">数量</th>
              <th width="200">变化数量</th>
              <th width="">小计</th>
            </tr>
          </thead>
          <tbody v-for="(p_item, p_index) in sizeColorArr" :key="p_index">
            <tr  v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index">
              <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
              <td>{{s_item.name}}</td>
              <td>
                <el-input-number v-model="s_item.number" size="small" :min="0" :precision="0" @focus="focusStock(p_item, s_item)" @blur="blurStock(p_item, s_item)" @change="changeStock(p_item, s_item)"></el-input-number>
              </td>
              <td>{{s_item.changeNum}}</td>
              <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.count}}</td>
            </tr>
          </tbody> 
        </table>
      </div>
      <div class="btn-wrap">
        <button class="cg-btn red big" @click="submitEditStock">确认修改库存数量</button>
      </div>
      
      <!-- <el-dialog title="修改颜色尺码" width="800px" :visible.sync="colorSizeEditShow"
        :close-on-click-modal="false"
      >
        <div class="cg-form-mod custom">
          <div class="line-lab req">请添加商品颜色</div>
          <div class="color-list-wrap">
            <div class="item" v-for="(item, index) in colorArr" :key="index">
                <i class="el-icon-check color-checked" v-if="item.color.length>0" @click="colorItemDel(item, index)"></i>
                <i class="color-unchecked" v-else></i>
                <el-input size="mini" class="w26" v-model.trim="item.color" placeholder="请输入商品颜色" @input="colorItemInput(item, index)"></el-input>
                <div class="error" v-if="item.err">
                  该颜色已存在！
                </div>
            </div>
          </div>
          <div class="line-lab req">请选择尺码类型</div>
          <div class="size-type-wrap">
            <el-radio-group v-model="sizeType" @change="handleSizeTypeChange">
              <el-radio :label="1">常规尺码</el-radio>
              <el-radio :label="2">裤装尺码</el-radio>
              <el-radio :label="3">童装尺码</el-radio>
            </el-radio-group>
          </div>
          <div class="size-list-wrap">
            <div v-show="sizeType == 1">
              <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList1" :label="item" :key="index"
              v-model="item.checked" @change="sizeItemChange"
              >{{item.dataName}}</el-checkbox>
            </div>
            <div v-show="sizeType == 2">
              <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList2" :label="item" :key="index"
                v-model="item.checked" @change="sizeItemChange"
              >{{item.dataName}}</el-checkbox>
            </div>
            <div v-show="sizeType == 3">
              <el-checkbox class="check-box" v-for="(item, index) in sizeTypeList3" :label="item" :key="index"
                v-model="item.checked" @change="sizeItemChange"
              >{{item.dataName}}</el-checkbox>
            </div>
          </div>
          <div class="btns">
            <button class="cg-btn" type="button" @click="colorSizeEditShow = false">取消</button>
            <button class="cg-btn red mgl-16" type="button" @click="colorSizeEditShow = false">确定</button>
          </div>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { getMallItemInfo, editStock } from '../../../api/supplier'
import { getDatasource } from '../../../api/public'
import { settlePrice, supplierPrice, accMul } from '../../../utils/tools'
import { mapGetters } from 'vuex'
export default {
    data() {
      return {
        goodsImage: '',
        goodsImageList: [],
        detail: {
          brand: '',
          fabricAndAccessoryStr: '',
          itemName: '',
          itemState:  '',
          itemUnqueNumber:  '',
          item_fee_splitting:  '',
          item_id:  '',
          item_parent_id:  '',
          item_submit_time:  '',
          mallItemFileUrl:  '',
          originPrice: '',
          price:  '',
          productCategory:  '',
          productContent:  '',
          sizeArr:  '',
          styleNumber:  '',
          totalStock:  '',
          user_id:  '',
        },
        sizeColorArr: [],

        // 弹框
        colorSizeEditShow: false,
        // 尺码
        sizeTypeList1: [],
        sizeTypeList2: [],
        sizeTypeList3: [],
        checkedSizes1: [], 
        checkedSizes2: [],
        checkedSizes3: [],
        finalCheckedSizes: [],

        sizeType: 1,

        // 颜色
        colorArr: [],
        colorSizeObj: {
          1: [],
          2: [],
          3: []
        },

        inputTimer: null

      }
    },
    inject: ['reload'],
    computed: {
      ...mapGetters(['userId']),
      settlePrice: function () {
        let rate = this.detail.item_fee_splitting.split(',')[1]
        rate = rate ? accMul(rate, 100) : ''
        return settlePrice(this.detail.price, rate)
      },
      supplierPrice: function () {
        let rate = this.detail.item_fee_splitting.split(',')[1]
        rate = rate ? accMul(rate, 100) : ''
        return supplierPrice(this.detail.price, rate)
      },
    },
    created() {
      console.log(this.$route)
      this.getMallItemInfo();
      this.getDatasource();
    },
    methods: {
      getMallItemInfo() {
        getMallItemInfo({
          itemId: this.$route.query.id,
          userId: this.userId
        }).then(res => {
          console.log(res)
          if (res.errorCode == 200) {
            this.detail = res.data[0]
            this.goodsImage = process.env.VUE_APP_IMG_PREV + res.data[0].mallItemFileUrl
            this.goodsImageList.push(this.goodsImage)
            try {
              let group = JSON.parse(res.data[0].sizeArr)
              console.log(group)
              let arr = group.group.map(item => {
                return {
                  color: item.color,
                  noDelete: true,
                  colorId: item.colorId,
                  count: item.sizeArr.reduce((total, item) => {
                    return total + item.number
                  }, 0),
                  sizeArr: item.sizeArr.map(size => {
                    return {
                      ...size,
                      oriNum: size.number,
                      changeNum: 0,
                      noEdit: true
                    }
                  })
                }
              })

              let colorArr = arr.map((item, index) => {
                return {
                  color: item.color,
                  key: index + 1,
                  noDelete: true,
                  colorId: item.colorId,
                }
              })
              this.colorArr = colorArr.concat({color: '', key: colorArr.length + 1})

              this.sizeColorArr = arr || []
              console.log(this.sizeColorArr)
            } catch (error) {
              console.log(error)
              this.sizeColorArr = []
              this.colorArr = [{color: '', key: 1}]
            }
          } else {
            this.$message.error(res.errorMsg || '获取详情数据异常')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      changeStock(p, s) {
        let changeNum = (s.number || 0) - s.oriNum;
        s.changeNum = changeNum == 0 ? 0 : changeNum > 0 ? '+' + changeNum : changeNum;

        this.sumStock(p, s)

        this.detail.totalStock = this.sizeColorArr.reduce((sum, item) => sum + item.count, 0)
      },
      focusStock(p, s) {
        console.log(p, s)
        if (s.number == 0) {
          s.number = undefined
        }
      },
      blurStock(p, s) {
        if (s.number === '' || s.number === undefined) {
          s.number = 0
        }
        this.sumStock(p, s)
      },
      // 计算小计
      sumStock(p,s) {
        let count = 0;
        p.sizeArr.forEach(element => {
          count += Math.round(element.number) || 0
        });
        p.count = count
      },
      // 提交修改
      submitEditStock() {
        if (this.colorArr.some(item => item.noDelete && item.color == '')) {
          return this.$message.error('原有的颜色值可修改但不能为空！')
        }
        if (this.sizeColorArr.length == 0) {
          return this.$message.error('至少需要有一个颜色组！')
        }
        this.$confirm('确定修改库存吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let colorSizeQuantity = {}
          let newColorSizeQuantity = {}

          // 所有数据 - 保留

          colorSizeQuantity['group'] = this.sizeColorArr.map(item => {
            return {
              color: item.color,
              colorId: item.colorId || '',
              sizeArr: item.sizeArr
            }
          })

          // colorSizeQuantity['group'] = this.sizeColorArr.filter(item => item.noDelete).map(item => {
          //   return {
          //     color: item.color,
          //     sizeArr: item.sizeArr.filter(ele => ele.noEdit)
          //   }
          // })

          newColorSizeQuantity['group'] = this.sizeColorArr.map(item => {
            return {
              color: item.color,
              sizeArr: item.sizeArr.filter(ele => !ele.noEdit)
            }
          })
          
          console.log(colorSizeQuantity)
          console.log(newColorSizeQuantity)


          let colorSizeQuantityStr = JSON.stringify(colorSizeQuantity)
          let newColorSizeQuantityStr = JSON.stringify(newColorSizeQuantity)

          console.log(colorSizeQuantityStr)
          console.log(newColorSizeQuantityStr)

          editStock({
            userId: this.userId,
            itemId: this.$route.query.id,
            colorSizeQuantityStr: colorSizeQuantityStr,
            newColorSizeQuantityStr: newColorSizeQuantityStr
          }).then(res => {
            console.log(res)
            if (res.errorCode == 200) {
              // this.$message.success('修改库存成功')
              this.$confirm('修改库存成功!', '提示', {
                  confirmButtonText: '继续修改',
                  cancelButtonText: '库存列表',
                  type: 'success',
                  center: true
                }).then(() => {
                  // 继续添加
                  this.reload()
                }).catch(() => {
                  this.$router.go(-1)
                });
            } else {
              this.$message.error(res.errorMsg || '修改库存失败')
            }
          }).catch(error => {
            console.log(error)
          })
        })
        
      },
      // 获取尺码数据
      getDatasource() {
        getDatasource({types: '10202,10203,10204'}).then(res => {
          console.log(res)
          if (res.errorCode == 200) {
            this.sizeTypeList1 = res.data.regularSize.list.map((item, index) => {
              return {
                ...item,
                key: 'regular'+ (index+1),
                checked: false,
                noEdit: false
              }
            })
            console.log(this.sizeTypeList1)
            this.sizeTypeList2 = res.data.pantsSize.list.map((item, index) => {
              return {
                ...item,
                key: 'pants'+ (index+1),
                checked: false,
                noEdit: false
              }
            })
            console.log(this.sizeTypeList2)
            this.sizeTypeList3 = res.data.childSize.list.map((item, index) => {
              return {
                ...item,
                key: 'child'+ (index+1),
                checked: false,
                noEdit: false
              }
            })
            console.log(this.sizeTypeList3)
            // this.createColorSizeTable('color')
          }
        })
      },
      // 编辑颜色尺码
      editColorSize() {
        this.colorSizeEditShow = true
        let checkedSizeArr = this.sizeColorArr[0].sizeArr.map(item => item.name)
        this.sizeType = this.judgeSizeType(checkedSizeArr)
        this['sizeTypeList' + this.sizeType].forEach(item => {
          if (checkedSizeArr.indexOf(item.dataName) > -1) {
            item.checked = true
            item.noEdit = true
          }
        })

        let sizeColorArr = this.sizeColorArr.map((item, index) => {
          return {
            ...item,
            noDelete: true,
            colorId: item.colorId,
            key: index + 1,
            sizeArr: this['sizeTypeList' + this.sizeType].map(ele => {
              let eleStock = item.sizeArr.filter(s => s.name == ele.dataName)
              console.log(eleStock)
              if (eleStock.length > 0) {
                return {
                  ...eleStock[0],
                  name: ele.dataName,
                  checked: ele.checked,
                  noEdit: ele.noEdit || false,
                  key: ele.key,
                  number: eleStock[0].number,
                  oriNum: eleStock[0].number,
                  changeNum: 0,
                  
                }
              } else {
                return {
                  name: ele.dataName,
                  checked: ele.checked,
                  key: ele.key,
                  number: 0,
                  oriNum: 0,
                  changeNum: 0
                }
              }
            })
          }
        })

        this.colorSizeObj[this.sizeType] = sizeColorArr.concat({
          color: '',
          key: this.colorArr.length,
          noDelete: false,
          count: 0,
          sizeArr: this['sizeTypeList' + this.sizeType].map(item=> {
            return {
              name: item.dataName,
              number: 0,
              checked: item.checked,
              key: item.key,
              oriNum: 0,
              changeNum: 0
            }
          })
        })

        console.log(this.colorSizeObj[this.sizeType])
      },

      // 判断是哪个尺码类型
      judgeSizeType(arr) {
        if (this.sizeTypeList1.some(item => item.dataName == arr[0])) {
          return 1
        }
        if (this.sizeTypeList2.some(item => item.dataName == arr[0])) {
          return 2
        }
        if (this.sizeTypeList3.some(item => item.dataName == arr[0])) {
          return 3
        }
      },

      // 输入颜色值
      colorItemInput (item, index) {
        if (index == this.colorArr.length - 1) {
          if (item.color.length>0) {
            this.colorArr.push({color: '', key: this.colorArr[this.colorArr.length-1].key + 1})
          }
        }
        if (item.noDelete && item.color == '') {
          item.err2 = true
        } else {
          item.err2 = false
          this.checkSameColor(item, index)
        }
        
      },
      // 判断颜色值是否重复
      checkSameColor (item, index) {
        if (item.color != '' && this.colorArr.some((ele, i) => i != index && ele.color == item.color)) {
          item.err = true
        } else {
          this.colorArr.forEach(ele => {
            if (ele.err) ele.err = false
          })
          if (this.inputTimer) clearTimeout(this.inputTimer)
          this.inputTimer = setTimeout(() => {
            this.createColorSizeTable('color')
            console.log(this.inputTimer)
          }, 500)
          
        }
      },
      // 删除颜色
      colorItemDel (item, index) {
        if (item.noDelete) return
        this.colorArr.splice(index, 1)
        this.createColorSizeTable('color', 'del', index)
      },

      // 尺码
      handleSizeTypeChange(value) {
        console.log(value)
        this.createColorSizeTable('color')
      },
      sizeItemChange(value) {
        this.createColorSizeTable('size')
      },

      // 生成表格
      createColorSizeTable (type, del, index) {
        if (type == 'color') {
          if (del == 'del') {
            for(let key in this.colorSizeObj) {
              if (this.colorSizeObj[key].length>0) {
                this.colorSizeObj[key].splice(index, 1)
              }
            }
          } else {
            console.log(this['sizeTypeList' + this.sizeType]);
            if (this.colorSizeObj[this.sizeType].length == 0) {
              this.colorSizeObj[this.sizeType] = this.colorArr.map(c_item => {
                return {
                  color: c_item.color,
                  key: c_item.key,
                  noDelete: c_item.noDelete || false,
                  colorId: c_item.colorId || '',
                  count: 0,
                  sizeArr: this['sizeTypeList' + this.sizeType].map(item=> {
                    return {
                      name: item.dataName,
                      number: 0,
                      checked: item.checked,
                      noEdit: item.noEdit || false,
                      key: item.key,
                      oriNum: item.oriNum,
                      changeNum: item.changeNum
                    }
                  })
                }
              })
            } else {
              this.colorArr.forEach((c_item, c_index) => {
                let curIndex = 0
                let colorFilter = this.colorSizeObj[this.sizeType].filter((c, i) => {
                    if (c.key == c_item.key) {
                      curIndex = i
                      return true
                    }
                  })
                  console.log('33333333---------', colorFilter)
                if (colorFilter.length == 0) {
                  console.log('22222222---------')
                  this.colorSizeObj[this.sizeType].push({
                    color: '',
                    key: c_item.key,
                    noDelete: c_item.noDelete || false,
                    colorId: c_item.colorId || '',
                    count: 0,
                    sizeArr: this['sizeTypeList' + this.sizeType].map(item=> {
                      return {
                        name: item.dataName,
                        number: 0,
                        checked: item.checked,
                        noEdit: item.noEdit || false,
                        key: item.key,
                        oriNum: 0,
                        changeNum: 0
                      }
                    })
                  })
                } else {
                  console.log('1111---------')
                  this.colorSizeObj[this.sizeType][curIndex].color = c_item.color
                }
              })
            }
          }
        }

        if (type == 'size') {
          this.colorSizeObj[this.sizeType].forEach(item => {
            item.sizeArr.forEach((ele, i) => {
              ele.checked = this['sizeTypeList' + this.sizeType][i].checked
            })
          })
        }

        console.log(this.colorSizeObj[this.sizeType]);
        this.sizeColorArr = this.colorSizeObj[this.sizeType].filter(item => item.color != '').map(ele=> {
          let checkedSizeArr = ele.sizeArr.filter(a => a.checked)
          return {
            ...ele,
            sizeArr: checkedSizeArr,
            count: checkedSizeArr.reduce((total, s) => {
                return total + s.number
            }, 0),
          }
        })
        console.log(this.sizeColorArr)
      },
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 1100px;
}
.stock-content {
  margin-top: 16px;
  padding: 8px 24px 24px;
  background: #fff;
}
.basic-wrap {
  padding: 24px 0;
  min-width: 1000px;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  height: 100px;
  .img-wrap {
    float: left;
    width: 100px; height: 100px;
    border: 1px solid #f0f0f0;
    .img {
      width: 100px; height: 100px;
    }
  }
  .basic-info {
    padding-left: 136px;
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
        &.tit {
           display: inline-block;
           vertical-align: top;
           width: 720px;
        }
      }
    }
  }
}

.cg-mod-title.mgt {
  margin-top: 32px;
}
.stock-data {
  height: 22px;
  width: 980px;
  margin: 24px 0;
  .line {
    float: left;
    width: 180px;
    font-size:14px;
    line-height:22px;
    .lab {
      color:rgba(0,0,0,0.85);
    }
    .val {
      color:rgba(0,0,0,0.65);
    }
  }
}
.stock-table {
  width: 980px;
  
  .table {
    border: 1px solid #E6E6E6;
    width: 980px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size:14px;
    tr {
      height: 50px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color:rgba(0,0,0,0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #E6E6E6;
      text-align: center;
      color:rgba(0,0,0,0.85);
    }
  }
}
.btn-wrap {
  width: 980px;
  padding: 40px 0;
  text-align: center;
}

.cg-form-mod.custom {
  padding: 0 0 32px;
  margin-top: 0;
  width: auto;
}
.size-type-wrap {
    margin-top: 8px;
  }
  .color-list-wrap {
    margin: 10px 0 15px;
    width: 980px;
    box-sizing: border-box;
    .item {
      position: relative;
      margin-bottom: 10px;
      padding-left: 24px;
      .color-checked {
        position: absolute;
        left: 0;
        top: 6px;
        color: #F81D22;
        font-weight: bold;
        font-size: 14px;
        border: 1px solid #F81D22;
        cursor: pointer;
        &.isdisabled {
          background-color: #F2F6FC;
          border-color: #DCDFE6;
          color: #C0C4CC;
          cursor: not-allowed;
        }
      }
      .error {
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
      }
    }
  }
  .size-list-wrap {
    margin-top: 16px;
    padding: 16px 16px 0;
    width: 980px;
    box-sizing: border-box;
    border: 1px solid #E6E6E6;
    background: rgba(0,0,0,0.02);
    .check-box {margin-bottom: 16px;}
  }
  .color-group {
    margin-top: 16px;
    .el-form-item {
      margin-bottom: 10px;
    }
  }
</style>